"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.form.title.edit': 'Edytuj Branżę',
    'branch.form.title.add': 'Dodaj Branżę',
    'branch.form.back': 'Wstecz',
    'branch.form.name.label': 'Nazwa',
    'branch.form.name.placeholder': 'Nazwa branży',
    'branch.form.color.label': 'Kolor',
    'branch.form.color.placeholder': 'Kolor branży',
    'branch.form.description.label': 'Opis',
    'branch.form.description.placeholder': 'Opis',
    'branch.form.submit.update': 'Zaktualizuj Branżę',
    'branch.form.submit.create': 'Utwórz Branżę',
};
